const PUBLIC_SUBSCRIPTION_BASE_PATH = '/abbonamenti/caf-patronato'

const publicSubscriptionRoutes = {
  promo: PUBLIC_SUBSCRIPTION_BASE_PATH,
  payment: `${PUBLIC_SUBSCRIPTION_BASE_PATH}/subscription-payment`,
  success: `${PUBLIC_SUBSCRIPTION_BASE_PATH}/subscription-success`,
  terms: `${PUBLIC_SUBSCRIPTION_BASE_PATH}/subscription-terms`,
}

const DASHBOARD_SUBSCRIPTION_BASE_PATH = '/dashboard/abbonamenti/caf-patronato'

const dashboardSubscriptionRoutes = {
  promo: DASHBOARD_SUBSCRIPTION_BASE_PATH,
  payment: `${DASHBOARD_SUBSCRIPTION_BASE_PATH}/subscription-payment`,
  success: `${DASHBOARD_SUBSCRIPTION_BASE_PATH}/subscription-success`,
  terms: `${DASHBOARD_SUBSCRIPTION_BASE_PATH}/subscription-terms`,
}

const getSubscriptionRoute = (routeKey, isDashboard = false) => {
  const routeMap = isDashboard
    ? dashboardSubscriptionRoutes
    : publicSubscriptionRoutes

  return routeMap[routeKey]
}

module.exports = {
  PUBLIC_SUBSCRIPTION_BASE_PATH,
  DASHBOARD_SUBSCRIPTION_BASE_PATH,
  publicSubscriptionRoutes,
  dashboardSubscriptionRoutes,
  getSubscriptionRoute,
}